import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RadioButtons from '../../../common/RadioButton';
import ContentCard from '../../../common/ContentCard';
import { data } from '../../../map/ImpactCard/dataSource';
import { connect } from 'react-redux';
import { getSelectedFilter } from '../selectors';
import { impactFilterRequested } from '../actions';
import { noop } from '../../../common/propTypes';
import CheckBox from '../../../common/CheckBox';
import { getUserPermissionsKeys } from '../../../screens/auth/selectors';
export function ImpactCard({ selected, onValueChange, onLoad, permissions }) {
    const [allSelected, setAllSelected] = useState(true);
    const filteredData = data.filter(
        (element) =>
            !element.isProtected ||
            permissions.indexOf(element.permission) > -1,
    );

    useEffect(() => {
        onLoad(allSelected ? null : filteredData[0].value);
    }, [allSelected]);

    const mainContent = (
        <RadioButtons
            data={filteredData}
            name={'impactCardRadioButtons'}
            selected={selected}
            onValueChange={onValueChange}
            allDisabled={allSelected}
        />
    );
    return (
        <ContentCard
            content={mainContent}
            heading={
                <>
                    <h2 className="title flex-grow-1">Impact Map</h2>
                    <CheckBox
                        label={'All'}
                        id={'campaign-checkbox'}
                        onClick={() => {
                            setAllSelected(!allSelected);
                        }}
                        selected={allSelected}
                        isBold={true}
                        cursorAllowed={true}
                        disabled={false}
                    />
                </>
            }
            subHeading={
                'Use this map to follow all pieces of litter picked up to date'
            }
            showDropDown={false}
        />
    );
}

ImpactCard.propTypes = {
    selected: PropTypes.string,
    onValueChange: PropTypes.func,
    onLoad: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.string),
};

ImpactCard.defaultProps = {
    selected: null,
    onValueChange: noop,
    onLoad: noop,
    permissions: [],
};

const mapStateToProps = (state) => {
    return {
        selected: getSelectedFilter(state),
        permissions: getUserPermissionsKeys(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onValueChange: (selected) => dispatch(impactFilterRequested(selected)),
        onLoad: (selected) => dispatch(impactFilterRequested(selected)),
    };
};

export const ConnectedImpactCard = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ImpactCard);

export default ConnectedImpactCard;
